import {$get, $postForm} from "./Ajax.ts";
import {$, getParentElementByTagName} from "./Dom.ts";
import {fadeIn} from "./Animate.ts";
import {createModale, hideModal, showModal} from "./Modal.ts";
import {refreshPage} from "./Utils.ts";
import {date_picker_init} from "./DatePicker.ts";

function UpdateDateReponse(event: DOMEvent<HTMLElement>) {
    event.preventDefault()
    const form = getParentElementByTagName(event.target, 'form') as HTMLFormElement
    const url = form?.getAttribute('action')
    if (url && form) {
        const data = new FormData(form)
        $postForm(url, data).then((response) => {
            if (response.body === "") {
                refreshPage()
            } else {
                window.location.href = response.body
            }
        }).catch(erreur => {
            $('#message-erreur-date')!.innerHTML = `<div class="fr-alert fr-alert--error" role="alert" >${erreur.message}</div>`
        })
    }
}

export const initDatefield = (className: string, container: HTMLElement | Document | null = document, ajax: boolean = true) => {
    if (container === null) return
    const element = $(className, container)
    element?.addEventListener('click', (e) => {
        e.preventDefault()
        const url_form = element?.getAttribute('data-url-form-pk')!;
        const modalBody = $('#modal-date-form-body')
        if (modalBody){
            const modale = createModale('modal-date-form')
            if (modale){
                showModal(modale.id, {})
                $get(url_form).then((response) => {
                    modalBody.innerHTML = response.body
                    fadeIn(modalBody)
                    $('.formDateModal')?.setAttribute('action', url_form)
                    if(ajax) {
                        $('.formDateModal')?.addEventListener('submit', UpdateDateReponse)
                        $('.submit_formDate')?.addEventListener('click', UpdateDateReponse)
                    }
                    $('.fr-btn--secondary[aria-controls="formDate"]', modale)?.addEventListener('click', () => hideModal("modal-date-form"))
                    date_picker_init();
                })
            }
        }

    })
}